<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">
        {{
          getProcedureTypes[$route.params.procedureType]
            ? getProcedureTypes[$route.params.procedureType].name
            : ""
        }}
        /
        {{
          centralization
            ? centralization.identifier + " - " + centralization.name
            : ""
        }}
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          apiModuleName="ANNOUNCEMENT"
          :searchModule="searchModule"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @Btn6="openAddress"
          @Btn7="openActions"
          @Btn8="checkApproved"
          @Btn9="announcementDetails"
          @Btn14="viewPdf"
          @Btn29="cancelAnnouncement"
          @Btn42="requestApprove"
          @Btn43="revertSigningFailed"
          @totalRecords="(x) => (totalRecords = x)"
        >
        </table-parent>
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "../mixins/announcementPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { ANNOUNCEMENT, GET_PAAP_CENTRALIZATION } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";
import { mapMutations, mapGetters } from "vuex";
import VerbalProcessProviders from "@/components/VerbalProcessProviders";
import Announcement from "@/components/Announcement";
import AssignmentActions from "@/components/AssignmentActions";
import verbalProcessPermMixin from "../mixins/verbalProcessPermMixin.js";

export default {
  name: "Achizitii",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },

  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
    VerbalProcessProviders,
  },

  data() {
    return {
      centralization: null,
      tableHead: [
        {
          title: "Numarul anunțului",
          queryKey: "announcementNumber",
          bottomHead: {
            quikFiltre: true,
          },
        },

        {
          title: "Data anunțului",
          queryKey: "announcementDate",
          bottomHead: {
            quikFiltre: "date",
          },
        },

        {
          title: "Data limită pentru transmiterea ofertelor",
          queryKey: "expireDate",
          bottomHead: {
            quikFiltre: "date",
          },
        },

        {
          title: "Limba de redactare a ofertei",
          queryKey: "language",
          bottomHead: {
            quikFiltre: true,
          },
        },

        {
          title: "Sursa de finanțare a contractului",
          queryKey: "financingSource",
          bottomHead: {
            quikFiltre: true,
          },
        },

        {
          title: "Perioada de valabilitate a ofertelor (zile)",
          queryKey: "valability",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Propunerea tehnică",
          queryKey: "technicalProposal",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Propunerea financiară",
          queryKey: "financialProposal",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Criteriul de atribuire",
          queryKey: "attributionCriteria",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          spacer: true,
          minimize: 1,
          fixed: {
            right: true,
          },
          queryKey: "status",
          bottomHead: {
            quikFiltre: "announcementStatus",
          },
        },
      ],
      tableModule: (x, y) =>
        ANNOUNCEMENT.get(
          x,
          y,
          `eq=paapCentralizationId,${this.$route.params.centralization}`
        ),

      searchModule: (x, y, _, query) => {
        let filter = `eq=paapCentralizationId,${this.$route.params.centralization}`;

        if (query) {
          filter += `&${query}`;
        }

        return ANNOUNCEMENT.get(x, y, filter);
      },
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  methods: {
    ...mapMutations(["setReferenceIdForPreview"]),

    reload() {
      this.reloadTable++;
    },
    prepareData(row) {
      const preparation = [
        row.announcementNumber || "",
        this.toDate(row.announcementDate) || "",
        this.toDate(row.expireDate) || "",
        row.language || "",
        row.financingSource || "",
        row.valability || "",
        row.technicalProposal || "",
        row.financialProposal || "",
        row.attributionCriteria || "",
        {
          draft: {
            border: "left",
            icon: "far fa-clock",
            css: "padding: 0.5rem;color:#f2da07;font-size: 2rem;",
            tooltip: "Draft",
          },
          generated: {
            border: "left",
            icon: "fas fa-pencil",
            css: "padding: 0.5rem;color:#569a36;font-size: 2rem;",
            tooltip: "Generat",
          },
          waiting_approve: {
            border: "left",
            icon: "fas fa-clock",
            css: "padding: 0.5rem;color:#f2da07;font-size: 2rem;",
            tooltip: "Așteptare aprobare",
          },
          signing_failed: {
            border: "left",
            icon: "fas fa-exclamation-triangle",
            css: "padding: 0.5rem;color:#ec4a4a;font-size: 2rem;",
            tooltip: "Semnare eșuată",
          },
          rejected: {
            border: "left",
            icon: "fas fa-times-circle",
            css: "padding: 0.5rem;color:#ec4a4a;font-size: 2rem;",
            tooltip: "Respins",
          },
          approved: {
            border: "left",
            icon: "fas fa-clipboard-check",
            css: "padding: 0.5rem;color:#569a36;font-size: 2rem;",
            tooltip: "Aprobat",
          },
          cancelled: {
            border: "left",
            icon: "fas fa-ban",
            css: "padding: 0.5rem;color:#ec4a4a;font-size: 2rem;",
            tooltip: "Anulat",
          },
        }[row.status] || "-",
      ];

      const x = this.PERMISIONS;

      const prepareBtn = [];
      if (row.status == "approved" && !row.assignmentDocuments?.length) {
        prepareBtn.push([
          7,
          "Crează achiziție",
          ["fas fa-gears", "font-size:2.2rem; color:green;"],
        ]);
      } else if (!row.assignmentDocuments?.length && row.status == "approved") {
        prepareBtn.push([
          -1,
          "Indisponibil crearea achiziție până la aprobarea anunțului",
          [
            "fas fa-gears",
            "font-size:2.2rem; color:green; opacity: 0.5; cursor: initial",
          ],
        ]);
      }

      prepareBtn.push(14);

      if (["draft", "rejected"].includes(row.status)) {
        prepareBtn.push(2);
      }

      if (row.status == "draft" || row.status == "rejected") {
        prepareBtn.push([
          42,
          "Trimite spre semnare",
          ["fas fa-signal-stream", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (row.status == "approved" && !row.assignmentDocuments?.length) {
        prepareBtn.push([
          29,
          "Anulează",
          ["fas fa-window-close", "font-size:2.2rem;color:#ec4a4a;"],
        ]);
      }

      if (row.status == "waiting_approve") {
        prepareBtn.push([
          6,
          "Deschide lucrarea",
          ["fas fa-book", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (["draft", "rejected", "signing_failed"].includes(row.status)) {
        prepareBtn.push(3);
      }

      if (row.status == "cancelled") {
        prepareBtn.push([
          9,
          "Detalii anulare",
          ["fas fa-circle-info", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (row.status == "waiting_approve" && x.edit === true) {
        prepareBtn.push([
          8,
          "Verifică aprobare",
          ["fas fa-sync", "font-size:2.2rem; color:#F2994A;"],
        ]);
      }

      if (row.status == "signing_failed" && x.edit === true) {
        prepareBtn.push([
          43,
          "Revenire din semnare eșuată",
          ["fas fa-redo", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return Object.assign(preparation, {
        _Data: row,
      });
    },

    viewPdf(data) {
      this.setReferenceIdForPreview({
        data: {
          id: data.id,
        },
        origin: "ANNOUNCEMENT_PDF",
      });
    },

    requestApprove(data) {
      const error = (msg) => {
        this.$toastr.e(msg || "Eroare semanre.");
        this.reload();
        this.setLoad();
      };

      this.setSafeLoad(12000);
      ANNOUNCEMENT.requestApprove(data.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            window.open(res.data.result.url, "_blank");
            this.reload();
            this.setLoad();
          } else {
            error(res.response);
          }
        })
        .catch(error);
    },

    openActions(item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Eroare necunoscută.");
        this.setLoad();
      };

      this.setLoad(true);

      ANNOUNCEMENT.getOne(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const a = res.data;
            this.$modal.show(
              DialogModal,
              {
                target: "ActiuniAchizitie",
                title: "Acțiuni achiziții",
                inputs: [
                  {
                    id: "assignmentActions",
                    type: "component",
                    component: AssignmentActions,
                    errReason: "",
                    componentProps: {
                      centralization: this.centralization,
                      announcement: a,
                    },
                  },
                ],
                closeBtnText: "Anulează",
                button: {
                  disabled: true,
                },
                customClass: "fullWidth",
              },
              {
                name: "ActiuniAchizitie",
                adaptive: true,
                width: "650px",
                height: "570px",
              }
            );
          } else {
            error();
          }
        })
        .catch((err) => {
          error(err.message);
        });

      this.setLoad();
    },

    editItem(item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Eroare necunoscută.");
        this.setLoad();
      };

      this.setLoad(true);

      ANNOUNCEMENT.getOne(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const announcementData = res.data;

            this.$modal.show(
              DialogModal,
              {
                target: "EDIT_Announcement",
                title: "Editare anunț",
                inputs: [
                  {
                    id: "announcement",
                    type: "component",
                    component: Announcement,
                    componentProps: { initial: announcementData },
                  },
                ],

                acceptFinish: (data) => {
                  const announcementUpdated = data.announcement;

                  delete announcementUpdated.assignmentDocuments;
                  delete announcementData.assignmentDocuments;
                  delete announcementUpdated.conectxAddressUrl;
                  delete announcementData.conectxAddressUrl;
                  delete announcementUpdated.conectxAddressUuid;
                  delete announcementData.conectxAddressUuid;
                  delete announcementUpdated.details;
                  delete announcementData.details;
                  delete announcementUpdated.numberOfReferences;
                  delete announcementData.numberOfReferences;
                  delete announcementUpdated.registrationDate;
                  delete announcementData.registrationDate;
                  delete announcementUpdated.registrationDatetime;
                  delete announcementData.registrationDatetime;
                  delete announcementUpdated.registrationNumber;
                  delete announcementData.registrationNumber;
                  delete announcementUpdated.verbalProcess;
                  delete announcementData.verbalProcess;

                  // if (announcement.announcementDate) {
                  //   const d = new Date(announcement.announcementDate);
                  //   d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
                  //   announcement.announcementDate = d.toISOString();
                  // }

                  // if (announcement.expireDate) {
                  //   const d = new Date(announcement.expireDate);
                  //   d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
                  //   announcement.expireDate = d.toISOString();
                  // }

                  for (const key in announcementUpdated) {
                    if (!announcementUpdated[key]) {
                      this.$toastr.w("Nu au fost completate toate secțiunile.");
                      return false;
                    }

                    if (
                      key === "departments" &&
                      announcementUpdated[key].length === 0
                    ) {
                      this.$toastr.w("Nu a fost selectat nici un departament.");
                      return false;
                    }
                  }

                  const changedFields = this.getEdited(announcementData, {
                    ...announcementUpdated,
                    announcementDate: new Date(
                      announcementUpdated.announcementDate
                    ).toISOString(),
                    expireDate: new Date(
                      announcementUpdated.expireDate
                    ).toISOString(),
                  });

                  if (!Object.keys(changedFields).length) {
                    this.$toastr.w("Nu au fost găsite modificări.");
                    return false;
                  }

                  data.announcement = changedFields;
                  return true;
                },

                closeBtnText: "Anulează",
                button: {
                  type: 2,
                  value: "Modifică",
                  handler: (data) => {
                    this.setSafeLoad(12000);
                    ANNOUNCEMENT.edit(item.id, {
                      ...data.announcement,
                    })
                      .then((res) => {
                        if (
                          this.checkHttpStatusCode(res?.meta?.HttpStatusCode)
                        ) {
                          this.$toastr.s("Anunțul a fost modificat.");
                          this.reload();
                          this.setLoad();
                        } else {
                          error(res.response);
                        }
                      })
                      .catch(error);
                  },
                },
                customClass: "custom-size",
              },
              {
                name: "EDIT_Announcement",
                adaptive: true,
                width: "1000px",
                height: "1000px",
              }
            );
          } else {
            error();
          }
        })
        .catch((err) => {
          error(err.message);
        });

      this.setLoad();
    },

    deleteItem(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteAnnouncement",
          title: "Șterge invitația de participare",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Anunțul nu a fost șters.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);
              ANNOUNCEMENT.delete(item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Anunțul a fost șters.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteAnnouncement",
          adaptive: true,
          width: "650",
          height: "400",
        }
      );
    },
    openAddress(item) {
      window.open(item.conectxAddressUrl, "_blank");
    },

    revertSigningFailed(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.setLoad(true);
      ANNOUNCEMENT.revertSigningFailed(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.$toastr.s("Anunțul a revenit în starea de draft.");
          } else {
            this.$toastr.w(res.response || res.message || "A apărut o eroare.");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toastr.e("A apărut o eroare.");
        })
        .finally(() => {
          this.reload();
          this.setLoad();
        });
    },

    cancelAnnouncement(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "CancelAnnouncement",
          title: "Anulează anunțul",
          inputs: [
            {
              label: "Motivul anulării",
              id: "details",
              type: "multy-inputs",
              componentProps: {
                minHeight: 300,
              },
              errReason: "Introduceți motivul anulării.",
            },
          ],
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Confirmă",
            handler: (data) => {
              const error = (msg) => {
                if (typeof msg === "object") {
                  msg = msg?.message;
                }
                this.$toastr.e(msg || "Anularea anunțului a eșuat.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);
              ANNOUNCEMENT.cancel(item.id, data)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Anunțul a fost anulat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "CancelAnnouncement",
          adaptive: true,
          width: "650",
          height: "600",
        }
      );
    },

    announcementDetails(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "CancelAnnouncementDetails",
          title: "Motivul anulării",
          inputs: [
            {
              id: "details",
              value: item.details,
              type: "multy-inputs",
              componentProps: {
                minHeight: 300,
                disabled: true,
              },
            },
          ],
          closeBtnText: "Închide",
        },
        {
          name: "CancelAnnouncementDetails",
          adaptive: true,
          width: "650",
          height: "600",
        }
      );
    },

    checkApproved(item) {
      this.setLoad(true);
      ANNOUNCEMENT.checkApproved(item.id)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.reload();
            this.$toastr.s("Starea anunțului a fost modificată");
          } else {
            this.$toastr.w(res.response || "A apărut o eroare.");
            this.reload();
          }
        })
        .catch(() => {
          this.$toastr.e("A apărut o eroare.");
        });

      this.setLoad();
    },
  },

  computed: {
    ...mapGetters(["getProcedureTypes"]),
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["approve", "edit", "delete"];

    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }

    GET_PAAP_CENTRALIZATION(this.$route.params.centralization).then((res) => {
      this.centralization = res.data;
      const path = this.$route.path;
      const val = path.slice(0, path.lastIndexOf("/"));

      this.$root.$emit("select-item", val.slice(0, val.lastIndexOf("/")));
    });
  },
};
</script>
<style>
.custom-size {
  max-width: 1200px !important;
  max-height: 100% !important;
}
</style>
